/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1BannerIdMutationResponse,
  DeleteApiV1BannerIdPathParams,
  DeleteApiV1BannerId401,
  DeleteApiV1BannerId404,
  DeleteApiV1BannerId500,
} from "../../types/bannerRegistroController/DeleteApiV1BannerId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1BannerId } from "../../clients/bannerRegistroController/deleteApiV1BannerId.ts";

export const deleteApiV1BannerIdMutationKey = () =>
  [{ url: "/api/v1/banner/:id" }] as const;

export type DeleteApiV1BannerIdMutationKey = ReturnType<
  typeof deleteApiV1BannerIdMutationKey
>;

export function deleteApiV1BannerIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1BannerIdMutationKey();
  return mutationOptions<
    DeleteApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
    >,
    { id: DeleteApiV1BannerIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1BannerId(id, config);
    },
  });
}

/**
 * @description Exclui o banner e todos os seus idiomas e turmas vinculados. **(Requer Authorization para autenticação)**
 * @summary Excluir banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export function useDeleteApiV1BannerId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1BannerIdMutationResponse,
      ResponseErrorConfig<
        DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
      >,
      { id: DeleteApiV1BannerIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1BannerIdMutationKey();

  const baseOptions = deleteApiV1BannerIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
    >,
    { id: DeleteApiV1BannerIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
    >,
    { id: DeleteApiV1BannerIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
    >,
    { id: DeleteApiV1BannerIdPathParams["id"] },
    TContext
  >;
}
